import * as actionType from "./constants";

const initialState = {
    getStatusDataResponse: {},
    updateStatusResponse: null,
    entityParams: {
        entity: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    },
    getStatusDropdwnResponse: {},
    restoreStatusLogResponse: {},
    addStatusResponse: {},
    deleteStatusResponse: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_STATUS_DATA_REQUEST:
            return {
                ...state,
                getStatusDataResponse: { isLoading: true }
            };
        case actionType.GET_STATUS_DATA_SUCCESS:
            return {
                ...state,
                getStatusDataResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_STATUS_DATA_FAILURE:
            return {
                ...state,
                getStatusDataResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_STATUS_REQUEST:
            return {
                ...state,
                updateStatusResponse: { isLoading: true }
            };
        case actionType.UPDATE_STATUS_SUCCESS:
            return {
                ...state,
                updateStatusResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_STATUS_FAILURE:
            return {
                ...state,
                updateStatusResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.STATUS_DROPDOWN_REQUEST:
            return {
                ...state,
                getStatusDropdwnResponse: { isLoading: true }
            };
        case actionType.STATUS_DROPDOWN_SUCCESS:
            return {
                ...state,
                getStatusDropdwnResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.STATUS_DROPDOWN_FAILURE:
            return {
                ...state,
                getStatusDropdwnResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_STATUS_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_STATUS_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };
        case actionType.RESTORE_STATUS_LOG_REQUEST:
            return {
                ...state,
                restoreStatusLogResponse: { isLoading: true }
            };
        case actionType.RESTORE_STATUS_LOG_SUCCESS:
            return {
                ...state,
                restoreStatusLogResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.RESTORE_STATUS_LOG_FAILURE:
            return {
                ...state,
                restoreStatusLogResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.POST_STATUS_REQUEST:
            return {
                ...state,
                addStatusResponse: { isLoading: true }
            };
        case actionType.POST_STATUS_SUCCESS:
            return {
                ...state,
                addStatusResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.POST_STATUS_FAILURE:
            return {
                ...state,
                addStatusResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.DELETE_STATUS_REQUEST:
            return {
                ...state,
                deleteStatusResponse: { isLoading: true }
            };
        case actionType.DELETE_STATUS_SUCCESS:
            return {
                ...state,
                deleteStatusResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_STATUS_FAILURE:
            return {
                ...state,
                deleteStatusResponse: { isLoading: false, success: false, ...action.error }
            };
        default:
            return state;
    }
};
